module.exports = __webpack_public_path__ + "4a8b845bdd899065dffe59d4cf8b4a92.svg";